import api from '../library/axios';

export default {
  getList(workspace_id, company_id, page, search) {
    return api({
      method: 'get',
      url: `/api/channels/${workspace_id}`,
      params: {
        company_id,
        page,
        search,
      },
    });
  },
  getAll(page, search, mm_lite) {
    return api({
      method: 'get',
      url: '/api/channels',
      params: {
        page,
        search,
        mm_lite,
      },
    });
  },
  createChannel(workspace_id, payload) {
    return api({
      method: 'post',
      url: `/api/channels/${workspace_id}`,
      data: payload,
    });
  },
  delete(workspace_id, channel_id) {
    return api({
      method: 'delete',
      url: `/api/channels/${workspace_id}/${channel_id}`,
    });
  },
  templateList({
    workspace_id,
    channel_id,
    company_id,
  }) {
    return api({
      url: `/api/broadcast/templates/${workspace_id}/${channel_id}/${company_id}`,
    });
  },
  checkTelegramProfile({
    type,
    token,
    workspace_id,
  }) {
    return api({
      method: 'post',
      url: `/api/channels/${workspace_id}/inquiry`,
      data: {
        type,
        token,
      },
    });
  },
  initLinkAge({ token }) {
    return api({
      method: 'post',
      url: '/api/wa-embed-signup/init',
      data: {
        token,
      },
    });
  },
  getEmbedPhoneNumber() {
    return api({
      url: '/api/wa-embed-signup/phone-numbers',
    });
  },
  getChannelProfile({
    channel_id,
    workspace_id,
  }) {
    return api({
      url: `/api/channels/${workspace_id}/${channel_id}/profile`,
    });
  },
  updateChannelProfile({
    channel_id,
    workspace_id,
    data,
  }) {
    return api({
      method: 'patch',
      url: `/api/channels/${workspace_id}/${channel_id}/profile`,
      data,
    });
  },
  getWorkspaces() {
    return api({
      method: 'get',
      url: '/api/backoffice/channels/workspaces',
    });
  },
  getDetail(key) {
    return api({
      method: 'get',
      url: `/api/backoffice/channels/waba/detail/${key}`,
    });
  },
  checkExist(form) {
    return api({
      method: 'post',
      url: '/api/backoffice/channels/waba/check',
      data: form,
    });
  },
  getOTP(form) {
    return api({
      method: 'post',
      url: '/api/backoffice/channels/waba/code',
      data: form,
    });
  },
  submitOTP(form) {
    return api({
      method: 'post',
      url: '/api/backoffice/channels/waba/verify',
      data: form,
    });
  },
  saveWorkspace(form) {
    return api({
      method: 'post',
      url: '/api/backoffice/channels/save/workspace',
      data: form,
    });
  },
  getMMLiteBusiness(business_id) {
    return api({
      method: 'get',
      url: `/api/backoffice/mm_lite/${business_id}/detail`,
    });
  },
  activateMMLite({ business_id, waba_list }) {
    return api({
      method: 'post',
      url: `/api/backoffice/mm_lite/${business_id}/activate`,
      data: {
        waba_list,
      },
    });
  },
  getVerificationStatus(business_id) {
    return api({
      method: 'get',
      url: `/api/backoffice/verification/${business_id}/status`,
    });
  },
  submitVerification(business_id, data) {
    return api({
      method: 'post',
      url: `/api/backoffice/verification/${business_id}/submit`,
      data,
    });
  },
  getChannelFeed({
    channel_id,
    workspace_id,
    company_id,
    query,
  }) {
    return api({
      url: `/api/channels/${workspace_id}/${channel_id}/${company_id}/feed`,
      params: query,
    });
  },
  getBlogs({
    workspace_id,
    channel_id,
    page,
    search,
  }) {
    return api({
      method: 'get',
      url: `/api/channels/${workspace_id}/${channel_id}/blog`,
      params: {
        page,
        search,
      },
    });
  },
  getChannelPhoneCall(workspace_id, company_id) {
    return api({
      method: 'get',
      url: `/api/channels/phone-call/${workspace_id}/${company_id}`,
    });
  },
  previewUrlIvr(id, workspace_id, type, company_id) {
    return api({
      url: `/api/channels/${workspace_id}/call/${id}/${type}/${company_id}/ivr-preview`,
    });
  },
  blockUnblock(workspace_id, channel_id) {
    return api({
      method: 'post',
      url: `/api/channels/${workspace_id}/${channel_id}/blocked`,
    });
  },
};
